const MENU_CURATION_TASK_PROBLEM_REASON = {
  ERROR: {
    label: 'Error',
    value: 'ERROR',
  },
  MISC: {
    label: 'Misc',
    value: 'MISC',
  },
  SCRAPING_ERROR: {
    label: 'Scraping Error',
    value: 'SCRAPING_ERROR',
  },
}

export default MENU_CURATION_TASK_PROBLEM_REASON
